import addSeconds from 'date-fns/addSeconds';
import differenceInDays from 'date-fns/differenceInDays';
import endOfDay from 'date-fns/endOfDay';
import parseISO from 'date-fns/parseISO';
import startOfDay from 'date-fns/startOfDay';

import type { Program, ProgramList } from '@shared/types/programs';

export const getDuration = (program: Program | ProgramList) => {
	let duration = 0;
	const { individual } = program;
	const { start_date, end_date } = individual || {};
	if (start_date && end_date) {
		const days = differenceInDays(
			addSeconds(endOfDay(parseISO(end_date)), 1),
			startOfDay(parseISO(start_date))
		);
		duration = days;
		console.log('duration',duration)
	}
	return duration;
};
